export default "/gift_banner_1.6d26267d-9a2285.png";